import { map, concat } from 'lodash';

export default class CollaboratorService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    getAll() {
        return this.apiService.get(`/users/me/team-members`).then((result) => result.data);
    }

    create(collaborator) {
        return this.updateAll([collaborator], []);
    }

    delete(collaborator) {
        return this.updateAll([], [collaborator]);
    }

    updateAll(addedCollaborators, removedCollaborators) {
        let operations = map(addedCollaborators, (collaborator) => {
            return {
                operation: 'create',
                email: collaborator.email
            };
        });

        operations = concat(operations, map(removedCollaborators, (collaborator) => {
            return {
                operation: 'delete',
                email: collaborator.email
            };
        }));

        return this.apiService.patch(`/users/me/team-members`, operations).then((result) => result.data);
    }
}



// WEBPACK FOOTER //
// ./src/application/service/user/collaborator.service.js